<template>
    <div class="run-renewals">
        <div class="row">
            <amf-select label="Renewal Month" caption="--Select Month--" v-model="renewalMonthId" :options="months"></amf-select>
            <amf-select label="Renewal Year" caption="--Select Year--" v-model="renewalYearId" :options="years"></amf-select>
        </div>
        <div class="row">
            <amf-checkbox label="All Employers" v-model="allEmployers" />
        </div>
        <div class="row" v-if="!allEmployers">
            <amf-textarea v-model="amfCodes" :columns="3" :rows="4" label="Enter list of AMF Codes. One per line">
            </amf-textarea>
        </div>
    </div>
</template>

<script>

export default {
    computed: {
        years() {
            let year = moment().year();
            let years = [];
            for (let i = -1; i < 3; i++) {
                years.push({name: year + i, id: parseInt(year + i)});
            }
            return years;
        }
    },
    data() {
        return {
            months: [
                        {name: "January", id: 1},
                        {name: "February", id: 2},
                        {name: "March", id: 3},
                        {name: "April", id: 4},
                        {name: "May", id: 5},
                        {name: "June", id: 6},
                        {name: "July", id: 7},
                        {name: "August", id: 8},
                        {name: "September", id: 9},
                        {name: "October", id: 10},
                        {name: "November", id: 11},
                        {name: "December", id: 12}
            ],
            amfCodes: null,
            allEmployers: true,
            renewalMonthId: null,
            renewalYearId: null,
            renewalTypeId: null,
            title: 'Run Renewals',
        };
    },
    methods: {
        async save() {
            let dto = {
                renewalMonth: this.renewalMonthId,
                renewalYear: this.renewalYearId,
                amfCodes: null
            };

            if(!this.allEmployers) {
                if(!this.amfCodes) {
                    toastService.error('Enter one or more AMF Codes');
                    return;
                } 

                dto.amfCodes = this.amfCodes.split('\n');
            }

            this.busy = true;
            try {
               await romeApi.post(`renewal`, dto);
            }
            finally {
                this.busy = false;
            }
            toastService.success("Renewals Successfully Submitted");
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/workflow/RunRenewals.vue